/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/iframe-has-title */
import React from 'react';

const InfoCompany = ({ profile }) => {
  return (
    <div className='info flex'>
      <div className='info__img flex-center' style={{ position: 'relative' }}>
        <img src={profile?.profile_img} alt='' />
        {profile?.register_can == 2 && (
          <div
            style={{
              position: 'absolute',
              bottom: 0,
              color: '#fff',
              fontSize: '12px',
              width: '100%',
              textAlign: 'center',
              backgroundColor: '#2196f3',
            }}
          >
            Đã đăng ký sử dụng
          </div>
        )}
      </div>
      <div className='info__content'>
        <h4>{profile?.name}</h4>
        <p>Doanh nghiệp đã được xác minh</p>
        <p
          style={{ marginTop: '10px' }}
        >{`${profile?.like_count} lượt yêu thích | ${profile?.register_count} lượt đăng ký sử dụng`}</p>
        <div className='box-btn flex'>
          {(profile?.feedback_can == 1 ||
            profile?.feedback_can == -1 ||
            profile?.feedback_can == 2) && (
            <div className='likepage flex-center'>
              <a
                className='flex-center'
                data-dismiss='modal'
                data-toggle='modal'
                data-target='#modal-like'
                style={{ color: 'white', cursor: 'pointer' }}
              >
                <i className='icon-like'></i> Yêu thích{' '}
              </a>
            </div>
          )}
          {(profile?.register_can == 1 || profile?.register_can == -1) && (
            <a
              href='Đăng ký sử dụng'
              title=''
              className='btn_register flex-center'
              data-dismiss='modal'
              data-toggle='modal'
              data-target='#modal-register-platform'
              style={{ cursor: 'pointer' }}
            >
              Đăng ký sử dụng
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default InfoCompany;
